import CompanyGroupDefaultView from '@/views/company/CompanyGroupDefaultView.vue'
import CompanyModuleDefaultView from '@/views/company/CompanyModuleDefaultView.vue'

import { NAVIGATION_ROUTE_TYPES/* , NAVIGATION_LAYERS */, CATEGORY_GROUP_KEYS, COMPANY_GROUPS_NAMES } from './routerMapConfig'
import { ROUTER_NAMES } from './routerNamesConfig'


/*
	Массив МОДУЛЕЙ

	В мета обязательно должны быть:
	- navigationRouteType
	- defaultTabView - описывает какой вид отображения нужно открыть при нажатии на ссылку

	обязательно один из вариантов:
	- title
	- titleTranslationKey

	опционально:
	- children - роуты для каждого вида отображения. в мета обязательно прописать navigationRouteType

	так же в мета зайдут перечень необходимых флагов прав доступа
*/
export const TEST_MODULES = [
	{
		path: 'test-module',
		name: 'CompanyGroupTestModuleTestPage',
		component: CompanyModuleDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
			defaultTabView: 'CompanyGroupTestModuleTestViewMapPage',
			title: 'Test module',
		},
		children: [
			{
				path: '',
				name: 'CompanyGroupTestModuleTestViewDashboardPage',
				component: () => import('@/views/company/test-group/test-module/CompanyModuleTestDashboardView.vue'),
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					isDynamicComponent: true,
				},
			},
			{
				path: 'map',
				name: 'CompanyGroupTestModuleTestViewMapPage',
				component: () => import('@/views/company/test-group/test-module/CompanyModuleTestMapView.vue'),
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					isDynamicComponent: true,
				},
			},
			// {
			// 	path: 'calendar',
			// 	name: 'CompanyGroupTestModuleTestViewCalendarPage',
			// 	component: () => import('@/views/company/test-group/test-module/CompanyModuleTestCalendarView.vue'),
			// 	meta: {
			// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 		isDynamicComponent: true,
			// 	},
			// },
		],
	},
	{
		path: 'test-custom-module',
		name: 'CompanyGroupTestCustomModuleTestPage',
		component: () => import('@/views/company/test-group/CompanyModuleTestCustomView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
			title: 'Custom test module',
			isDynamicComponent: true,
		},
	},
	{
		path: 'test-select-module',
		name: 'CompanyGroupTestCustomModuleSelectPage',
		component: () => import('@/views/company/test-group/CompanyModuleTestSelectView.vue'),
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
			title: 'Select module',
			isDynamicComponent: true,
		},
	},
]


/*
	Массив ГРУПП которые в сайдбаре

	В мета обязательно должны быть:
	- navigationRouteType
	- categoryKey
	- defaultModule - описывает какой модуль нужно открыть при нажатии на ссылке в сайдбаре

	обязательно один из вариантов:
	- title
	- titleTranslationKey

	опционально:
	- iconKey

	так же в мета зайдут перечень необходимых флагов прав доступа
*/
export const COMPANY_GROUPS = [
	{
		path: 'test-group',
		name: COMPANY_GROUPS_NAMES.TEST,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.DEVELOP,
			defaultModule: 'CompanyGroupTestModuleTestPage',
			// CompanyGroupTestCustomModuleTestPage
			title: 'Test group',
			iconKey: 'dev',

			hideInProduction: true,
		},
		children: TEST_MODULES,
	},

	// Planning
	{
		path: 'crop-production',
		name: COMPANY_GROUPS_NAMES.PLANNING__CROP_PRODUCTION,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.PLANNING,
			defaultModule: 'CompanyGroupCropProductionModuleCropsStructurePage',
			iconKey: 'conditionOfCrops',
			titleTranslationKey: 'menu.Crop production',
		},
		children: [
			{
				path: 'crops-structure',
				name: 'CompanyGroupCropProductionModuleCropsStructurePage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.CROPS_STRUCTURES.DASHBOARD,
					titleTranslationKey: 'menu.Crop rotation',
				},
				children: [
					{
						path: 'dashboard',
						name: ROUTER_NAMES.CROPS_STRUCTURES.DASHBOARD,
						component: () => import('@/views/company/crop-production-group/crops-structure-module/CompanyModuleCropsStructureDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupCropProductionModuleCropsStructureTablePage',
						component: () => import('@/views/company/crop-production-group/crops-structure-module/CompanyModuleCropsStructureTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupCropProductionModuleCropsStructureMapPage',
						component: () => import('@/views/company/crop-production-group/crops-structure-module/CompanyModuleCropsStructureMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'timeline',
						name: 'CompanyGroupCropProductionModuleCropsStructureTimelinePage',
						component: () => import('@/views/company/crop-production-group/crops-structure-module/CompanyModuleCropsStructureTimelineView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupCropProductionModuleCropsStructureCalendarPage',
						component: () => import('@/views/company/crop-production-group/crops-structure-module/CompanyModuleCropsStructureCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'technological-cards',
				name: 'CompanyGroupCropProductionModuleTechnologicalCardsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupCropProductionModuleTechnologicalCardsTablePage',
					titleTranslationKey: 'menu.Technological cards',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupCropProductionModuleTechnologicalCardsTablePage',
						component: () => import('@/views/company/crop-production-group/technological-cards-module/CompanyModuleTechnologicalCardsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'execution-stages',
				name: 'CompanyGroupCropProductionModuleExecutionStagesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupCropProductionModuleExecutionStagesTablePage',
					titleTranslationKey: 'menu.Execution stages',

					// hideInProduction: true,
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupCropProductionModuleExecutionStagesTablePage',
						component: () => import('@/views/company/crop-production-group/execution-stages-module/CompanyModuleExecutionStagesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		],
	},

	{
		path: 'transportation',
		name: COMPANY_GROUPS_NAMES.PLANNING__TRANSPORTATION,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.PLANNING,
			defaultModule: 'CompanyGroupTransportationModuleRoutesPage',
			iconKey: 'street',
			titleTranslationKey: 'menu.Transportation',

			// hideInProduction: true,
		},
		children: [
			{
				path: 'transportation-plan',
				name: 'CompanyGroupTransportationModuleTransportationPlanPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTransportationModuleTransportationPlanTablePage',
					titleTranslationKey: 'menu.Transportation plan',

					hideInProduction: true,
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupTransportationModuleTransportationPlanDashboardPage',
						component: () => import('@/views/company/transportation-group/transportation-plan-module/CompanyModuleTransportationPlanDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupTransportationModuleTransportationPlanTablePage',
						component: () => import('@/views/company/transportation-group/transportation-plan-module/CompanyModuleTransportationPlanTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupTransportationModuleTransportationPlanMapPage',
						component: () => import('@/views/company/transportation-group/transportation-plan-module/CompanyModuleTransportationPlanMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupTransportationModuleTransportationPlanCalendarPage',
						component: () => import('@/views/company/transportation-group/transportation-plan-module/CompanyModuleTransportationPlanCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					// {
					// 	path: 'timeline',
					// 	name: 'CompanyGroupTransportationModuleTransportationPlanTimelinePage',
					// 	component: () => import('@/views/company/transportation-group/transportation-plan-module/CompanyModuleTransportationPlanTimelineView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
				],
			},
			{
				path: 'transportation-regulations',
				name: 'CompanyGroupTransportationModuleTransportationRegulationsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTransportationModuleTransportationRegulationsTablePage',
					titleTranslationKey: 'menu.Transportation regulations',

					hideInProduction: true,
				},
				children: [
					// {
					// 	path: 'dashboard',
					// 	name: 'CompanyGroupTransportationModuleTransportationRegulationsDashboardPage',
					// 	component: () => import('@/views/company/transportation-group/transportation-regulations-module/CompanyModuleTransportationRegulationsDashboardView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
					{
						path: 'table',
						name: 'CompanyGroupTransportationModuleTransportationRegulationsTablePage',
						component: () => import('@/views/company/transportation-group/transportation-regulations-module/CompanyModuleTransportationRegulationsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					// {
					// 	path: 'map',
					// 	name: 'CompanyGroupTransportationModuleTransportationRegulationsMapPage',
					// 	component: () => import('@/views/company/transportation-group/transportation-regulations-module/CompanyModuleTransportationRegulationsMapView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
					// {
					// 	path: 'timeline',
					// 	name: 'CompanyGroupTransportationModuleTransportationRegulationsTimelinePage',
					// 	component: () => import('@/views/company/transportation-group/transportation-regulations-module/CompanyModuleTransportationRegulationsTimelineView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
				],
			},
			{
				path: 'routes',
				name: 'CompanyGroupTransportationModuleRoutesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTransportationModuleRoutesTablePage',
					titleTranslationKey: 'menu.Routes',

					// hideInProduction: true,
				},
				children: [
					// {
					// 	path: 'dashboard',
					// 	name: 'CompanyGroupTransportationModuleRoutesDashboardPage',
					// 	component: () => import('@/views/company/transportation-group/routes-module/CompanyModuleRoutesDashboardView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
					{
						path: 'table',
						name: 'CompanyGroupTransportationModuleRoutesTablePage',
						component: () => import('@/views/company/transportation-group/routes-module/CompanyModuleRoutesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					// {
					// 	path: 'map',
					// 	name: 'CompanyGroupTransportationModuleRoutesMapPage',
					// 	component: () => import('@/views/company/transportation-group/routes-module/CompanyModuleRoutesMapView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
					// {
					// 	path: 'timeline',
					// 	name: 'CompanyGroupTransportationModuleRoutesTimelinePage',
					// 	component: () => import('@/views/company/transportation-group/routes-module/CompanyModuleRoutesTimelineView.vue'),
					// 	meta: {
					// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
					// 		isDynamicComponent: true,

					// 		hideInProduction: true,
					// 	},
					// },
				],
			},
			{
				path: 'execution-stages',
				name: 'CompanyGroupTransportationModuleExecutionStagesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTransportationModuleExecutionStagesDashboardPage',
					titleTranslationKey: 'menu.Execution stages',

					hideInProduction: true,
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupTransportationModuleExecutionStagesDashboardPage',
						component: () => import('@/views/company/transportation-group/execution-stages-module/CompanyModuleExecutionStagesDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'maintenance',
		name: COMPANY_GROUPS_NAMES.PLANNING__MAINTENANCE,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.PLANNING,
			defaultModule: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsPage',
			iconKey: 'maintenanceAndRepairs', // ???
			titleTranslationKey: 'menu.Maintenance',

			hideInProduction: true,
		},
		children: [
			{
				path: 'maintenance-regulations',
				name: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsTablePage',
					titleTranslationKey: 'menu.Maintenance regulations',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsDashboardPage',
						component: () => import('@/views/company/maintenance-group/maintenance-regulations-module/CompanyModuleMaintenanceRegulationsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsTablePage',
						component: () => import('@/views/company/maintenance-group/maintenance-regulations-module/CompanyModuleMaintenanceRegulationsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsCalendarPage',
						component: () => import('@/views/company/maintenance-group/maintenance-regulations-module/CompanyModuleMaintenanceRegulationsCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupMaintenanceModuleMaintenanceRegulationsMapPage',
						component: () => import('@/views/company/maintenance-group/maintenance-regulations-module/CompanyModuleMaintenanceRegulationsMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'repair-plan',
				name: 'CompanyGroupMaintenanceModuleRepairPlanPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMaintenanceModuleRepairPlanTablePage',
					titleTranslationKey: 'menu.Repair Plan',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupMaintenanceModuleRepairPlanDashboardPage',
						component: () => import('@/views/company/maintenance-group/repair-plan-module/CompanyModuleRepairPlanDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupMaintenanceModuleRepairPlanTablePage',
						component: () => import('@/views/company/maintenance-group/repair-plan-module/CompanyModuleRepairPlanTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupMaintenanceModuleRepairPlanCalendarPage',
						component: () => import('@/views/company/maintenance-group/repair-plan-module/CompanyModuleRepairPlanCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupMaintenanceModuleRepairPlanMapPage',
						component: () => import('@/views/company/maintenance-group/repair-plan-module/CompanyModuleRepairPlanMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			// Add Stages of execution
		]
	},

	{
		path: 'projects',
		name: COMPANY_GROUPS_NAMES.PLANNING__PROJECTS,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.PLANNING,
			defaultModule: 'CompanyGroupProjectsModuleProcessesPage',
			iconKey: 'plan',
			titleTranslationKey: 'menu.projects',
		},
		children: [
			{
				path: 'processes',
				name: 'CompanyGroupProjectsModuleProcessesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.PROJECTS.LIST,
					titleTranslationKey: 'menu.processes',
				},
				children: [
					{
						path: 'dashboard',
						name: ROUTER_NAMES.PROJECTS.DASHBOARD,
						component: () => import('@/views/company/projects-group/processes-module/CompanyModuleProcessesDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'table',
						name: ROUTER_NAMES.PROJECTS.LIST,
						component: () => import('@/views/company/projects-group/processes-module/CompanyModuleProcessesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'regulations',
				name: 'CompanyGroupProjectsModuleRegulationsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupProjectsModuleRegulationsTablePage',
					titleTranslationKey: 'menu.regulations',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupProjectsModuleRegulationsTablePage',
						component: () => import('@/views/company/projects-group/regulations-module/CompanyModuleRegulationsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'process-stages',
				name: 'CompanyGroupProjectsModuleProcessStagesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupProjectsModuleProcessStagesTablePage',
					titleTranslationKey: 'menu.processStages',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupProjectsModuleProcessStagesTablePage',
						component: () => import('@/views/company/projects-group/process-stages-module/CompanyModuleProcessStagesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		],
	},

	// Works
	{
		path: 'my-tasks',
		name: COMPANY_GROUPS_NAMES.WORKS__MY_TASKS,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.WORKS,
			defaultModule: 'CompanyGroupMyTasksModuleToBeCompletedPage',
			iconKey: 'doneAndClose',
			titleTranslationKey: 'menu.My tasks',
		},
		children: [
			{
				path: 'to-be-completed',
				name: 'CompanyGroupMyTasksModuleToBeCompletedPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMyTasksModuleToBeCompletedTablePage',
					titleTranslationKey: 'menu.To be completed',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupMyTasksModuleToBeCompletedTablePage',
						component: () => import('@/views/company/my-tasks-group/to-be-completed-module/CompanyModuleToBeCompletedTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'submit-result',
				name: 'CompanyGroupMyTasksModuleSubmitResultPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMyTasksModuleSubmitResultTablePage',
					titleTranslationKey: 'menu.Submit result',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupMyTasksModuleSubmitResultDashboardPage',
						component: () => import('@/views/company/my-tasks-group/submit-result-module/CompanyModuleSubmitResultDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupMyTasksModuleSubmitResultTablePage',
						component: () => import('@/views/company/my-tasks-group/submit-result-module/CompanyModuleSubmitResultTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupMyTasksModuleSubmitResultCalendarPage',
						component: () => import('@/views/company/my-tasks-group/submit-result-module/CompanyModuleSubmitResultCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'control',
				name: 'CompanyGroupMyTasksModuleControlPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMyTasksModuleControlTablePage',
					titleTranslationKey: 'menu.To control',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupMyTasksModuleControlDashboardPage',
						component: () => import('@/views/company/my-tasks-group/control-module/CompanyModuleControlDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupMyTasksModuleControlTablePage',
						component: () => import('@/views/company/my-tasks-group/control-module/CompanyModuleControlTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupMyTasksModuleControlCalendarPage',
						component: () => import('@/views/company/my-tasks-group/control-module/CompanyModuleControlCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'make-out-incidents',
				name: 'CompanyGroupMyTasksModuleMakeOutIncidentsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMyTasksModuleMakeOutIncidentsTablePage',
					titleTranslationKey: 'menu.Make out incidents',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupMyTasksModuleMakeOutIncidentsDashboardPage',
						component: () => import('@/views/company/my-tasks-group/make-out-incidents-module/CompanyModuleMakeOutIncidentsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupMyTasksModuleMakeOutIncidentsTablePage',
						component: () => import('@/views/company/my-tasks-group/make-out-incidents-module/CompanyModuleMakeOutIncidentsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupMyTasksModuleMakeOutIncidentsCalendarPage',
						component: () => import('@/views/company/my-tasks-group/make-out-incidents-module/CompanyModuleMakeOutIncidentsCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'notifications',
				name: 'CompanyGroupMyTasksModuleNotificationsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupMyTasksModuleNotificationsTablePage',
					titleTranslationKey: 'menu.Notifications',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupMyTasksModuleNotificationsTablePage',
						component: () => import('@/views/company/my-tasks-group/notifications-module/CompanyModuleNotificationsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'control',
		name: COMPANY_GROUPS_NAMES.WORKS__CONTROL,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.WORKS,
			defaultModule: 'CompanyGroupControlModuleViolationsPage',
			iconKey: 'rang',
			titleTranslationKey: 'menu.Control',
		},
		children: [
			{
				path: 'violations',
				name: 'CompanyGroupControlModuleViolationsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupControlModuleViolationsTablePage',
					titleTranslationKey: 'menu.Violations',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupControlModuleViolationsDashboardPage',
						component: () => import('@/views/company/control-group/violations-module/CompanyModuleViolationsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupControlModuleViolationsTablePage',
						component: () => import('@/views/company/control-group/violations-module/CompanyModuleViolationsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupControlModuleViolationsCalendarPage',
						component: () => import('@/views/company/control-group/violations-module/CompanyModuleViolationsCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'employee-activity',
				name: 'CompanyGroupControlModuleEmployeeActivityPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupControlModuleEmployeeActivityTablePage',
					titleTranslationKey: 'menu.Employee activity',

					hideInProduction: true,
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupControlModuleEmployeeActivityDashboardPage',
						component: () => import('@/views/company/control-group/employee-activity-module/CompanyModuleEmployeeActivityDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupControlModuleEmployeeActivityTablePage',
						component: () => import('@/views/company/control-group/employee-activity-module/CompanyModuleEmployeeActivityTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupControlModuleEmployeeActivityCalendarPage',
						component: () => import('@/views/company/control-group/employee-activity-module/CompanyModuleEmployeeActivityCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'incidents',
				name: 'CompanyGroupControlModuleIncidentsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupControlModuleIncidentsTablePage',
					titleTranslationKey: 'menu.Incidents',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupControlModuleIncidentsTablePage',
						component: () => import('@/views/company/control-group/incidents-module/CompanyModuleIncidentsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'dashboard',
						name: 'CompanyGroupControlModuleIncidentsDashboardPage',
						component: () => import('@/views/company/control-group/incidents-module/CompanyModuleIncidentsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'events',
				name: 'CompanyGroupControlModuleEventsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.EVENTS.TABLE,
					titleTranslationKey: 'menu.Events',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.EVENTS.TABLE,
						component: () => import('@/views/company/control-group/events-module/CompanyModuleEventsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'works-in-field',
		name: COMPANY_GROUPS_NAMES.WORKS__FIELD,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.WORKS,
			defaultModule: 'CompanyGroupWorksInFieldModuleAllFieldWorksPage',
			iconKey: 'mapTraktor',
			titleTranslationKey: 'menu.Field works',
		},
		children: [
			{
				path: 'all-field-works',
				name: 'CompanyGroupWorksInFieldModuleAllFieldWorksPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.TABLE,
					titleTranslationKey: 'menu.Field orders',
				},
				children: [
					{
						path: 'analytics',
						name: ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.ANALYTICS,
						component: () => import('@/views/company/works-in-field-group/all-field-works-module/CompanyModuleAllFieldWorksAnalyticsView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'table',
						name: ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.TABLE,
						component: () => import('@/views/company/works-in-field-group/all-field-works-module/CompanyModuleAllFieldWorksTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.MAP,
						component: () => import('@/views/company/works-in-field-group/in-work-module/CompanyModuleInWorkMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},

			{
				path: 'operational-plan',
				name: 'CompanyGroupWorksInFieldModuleOperationalPlanPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupWorksInFieldModuleOperationalPlanTablePage',
					titleTranslationKey: 'menu.fieldOrdersPlanner',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupWorksInFieldModuleOperationalPlanTablePage',
						component: () => import('@/views/company/works-in-field-group/operational-plan-module/CompanyModuleOperationalPlanTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},

			{
				path: 'scheduled',
				name: 'CompanyGroupWorksInFieldModuleScheduledPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.ACTIVE_PLAN_WORKS.TABLE,
					titleTranslationKey: 'menu.Scheduled',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.ACTIVE_PLAN_WORKS.TABLE,
						component: () => import('@/views/company/works-in-field-group/scheduled-module/CompanyModuleScheduledTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			// {
			// 	path: 'in-work',
			// 	name: 'CompanyGroupWorksInFieldModuleInWorkPage',
			// 	component: CompanyModuleDefaultView,
			// 	meta: {
			// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
			// 		defaultTabView: ROUTER_NAMES.FIELD_DONE_WORKS_IN_PROGRESS.TABLE,
			// 		titleTranslationKey: 'menu.In progress',
			// 	},
			// 	children: [
			// 		{
			// 			path: 'dashboard',
			// 			name: 'CompanyGroupWorksInFieldModuleInWorkDashboardPage',
			// 			component: () => import('@/views/company/works-in-field-group/in-work-module/CompanyModuleInWorkDashboardView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,

			// 				hideInProduction: true,
			// 			},
			// 		},
			// 		{
			// 			path: 'table',
			// 			name: ROUTER_NAMES.FIELD_DONE_WORKS_IN_PROGRESS.TABLE,
			// 			component: () => import('@/views/company/works-in-field-group/in-work-module/CompanyModuleInWorkTableView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,
			// 			},
			// 		},
			// 		{
			// 			path: 'map',
			// 			name: ROUTER_NAMES.FIELD_DONE_WORKS_IN_PROGRESS.MAP,
			// 			component: () => import('@/views/company/works-in-field-group/in-work-module/CompanyModuleInWorkMapView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,
			// 			},
			// 		},
			// 		{
			// 			path: 'calendar',
			// 			name: 'CompanyGroupWorksInFieldModuleInWorkCalendarPage',
			// 			component: () => import('@/views/company/works-in-field-group/in-work-module/CompanyModuleInWorkCalendarView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,

			// 				hideInProduction: true,
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'done',
			// 	name: 'CompanyGroupWorksInFieldModuleDonePage',
			// 	component: CompanyModuleDefaultView,
			// 	meta: {
			// 		navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
			// 		defaultTabView: 'CompanyGroupWorksInFieldModuleDoneTablePage',
			// 		titleTranslationKey: 'menu.Completed',
			// 	},
			// 	children: [
			// 		{
			// 			path: 'dashboard',
			// 			name: 'CompanyGroupWorksInFieldModuleDoneDashboardPage',
			// 			component: () => import('@/views/company/works-in-field-group/done-module/CompanyModuleDoneDashboardView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,

			// 				hideInProduction: true,
			// 			},
			// 		},
			// 		{
			// 			path: 'table',
			// 			name: 'CompanyGroupWorksInFieldModuleDoneTablePage',
			// 			component: () => import('@/views/company/works-in-field-group/done-module/CompanyModuleDoneTableView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,
			// 			},
			// 		},
			// 		{
			// 			path: 'calendar',
			// 			name: 'CompanyGroupWorksInFieldModuleDoneCalendarPage',
			// 			component: () => import('@/views/company/works-in-field-group/done-module/CompanyModuleDoneCalendarView.vue'),
			// 			meta: {
			// 				navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
			// 				isDynamicComponent: true,

			// 				hideInProduction: true,
			// 			},
			// 		},
			// 	],
			// },
		]
	},

	{
		path: 'logistics',
		name: COMPANY_GROUPS_NAMES.WORKS__LOGISTICS,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.WORKS,
			defaultModule: 'CompanyGroupLogisticsModuleWaybillsRequestsPage',
			iconKey: 'mapPathOrder',
			titleTranslationKey: 'menu.Logistics',
		},
		children: [
			{
				path: 'waybills',
				name: 'CompanyGroupLogisticsModuleWaybillsRequestsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.LOGISTICS.WAYBILLS.TABLE,
					titleTranslationKey: 'menu.logisticOrders',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.LOGISTICS.WAYBILLS.TABLE,
						component: () => import('@/views/company/logistics-group/waybills-module/CompanyModuleWaybillsRequestsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: ROUTER_NAMES.LOGISTICS.WAYBILLS.MAP,
						component: () => import('@/views/company/logistics-group/waybills-module/CompanyModuleWaybillsRequestsMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'transportation-requests',
				name: 'CompanyGroupLogisticsModuleTransportationRequestsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.LOGISTICS.TRANSPORTATION_REQUESTS.TABLE,
					titleTranslationKey: 'menu.transportationRequests',
					hideInProduction: true,
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.LOGISTICS.TRANSPORTATION_REQUESTS.TABLE,
						component: () => import('@/views/company/logistics-group/transportation-requests-module/CompanyModuleTransportationRequestsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'trip-planner',
				name: 'CompanyGroupLogisticsModuleTripPlannerPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.LOGISTICS.TRIP_PLANNER.TABLE,
					titleTranslationKey: 'menu.tripPlanner',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.LOGISTICS.TRIP_PLANNER.TABLE,
						component: () => import('@/views/company/logistics-group/trip-planner-module/CompanyModuleTripPlannerTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			// CARGO_TRANSPORTED
			{
				path: 'cargo-transported',
				name: 'CompanyGroupLogisticsModuleCargoTransportedPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.LOGISTICS.CARGO_TRANSPORTED.TABLE,
					titleTranslationKey: 'menu.cargoTransported',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.LOGISTICS.CARGO_TRANSPORTED.TABLE,
						component: () => import('@/views/company/logistics-group/cargo-transported-module/CompanyModuleCargoTransportedTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'repair-work',
		name: COMPANY_GROUPS_NAMES.WORKS__REPAIR,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.WORKS,
			defaultModule: 'CompanyGroupRepairWorkModuleScheduledPage',
			iconKey: 'repair',
			titleTranslationKey: 'menu.Repair work',

			hideInProduction: true,
		},
		children: [
			{
				path: 'scheduled',
				name: 'CompanyGroupRepairWorkModuleScheduledPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupRepairWorkModuleScheduledTablePage',
					titleTranslationKey: 'menu.Scheduled',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupRepairWorkModuleScheduledDashboardPage',
						component: () => import('@/views/company/repair-work-group/scheduled-module/CompanyModuleScheduledDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupRepairWorkModuleScheduledTablePage',
						component: () => import('@/views/company/repair-work-group/scheduled-module/CompanyModuleScheduledTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupRepairWorkModuleScheduledCalendarPage',
						component: () => import('@/views/company/repair-work-group/scheduled-module/CompanyModuleScheduledCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'in-work',
				name: 'CompanyGroupRepairWorkModuleInWorkPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupRepairWorkModuleInWorkTablePage',
					titleTranslationKey: 'menu.In progress',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupRepairWorkModuleInWorkDashboardPage',
						component: () => import('@/views/company/repair-work-group/in-work-module/CompanyModuleInWorkDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupRepairWorkModuleInWorkTablePage',
						component: () => import('@/views/company/repair-work-group/in-work-module/CompanyModuleInWorkTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupRepairWorkModuleInWorkCalendarPage',
						component: () => import('@/views/company/repair-work-group/in-work-module/CompanyModuleInWorkCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'done',
				name: 'CompanyGroupRepairWorkModuleDonePage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupRepairWorkModuleDoneTablePage',
					titleTranslationKey: 'menu.Done',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupRepairWorkModuleDoneDashboardPage',
						component: () => import('@/views/company/repair-work-group/done-module/CompanyModuleDoneDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupRepairWorkModuleDoneTablePage',
						component: () => import('@/views/company/repair-work-group/done-module/CompanyModuleDoneTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'calendar',
						name: 'CompanyGroupRepairWorkModuleDoneCalendarPage',
						component: () => import('@/views/company/repair-work-group/done-module/CompanyModuleDoneCalendarView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'project-tasks',
		name: COMPANY_GROUPS_NAMES.WORKS__PROJECT_TASKS,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.WORKS,
			defaultModule: 'CompanyGroupProjectTasksModulePlannedTasksPage',
			iconKey: 'task',
			titleTranslationKey: 'menu.projectTasks',
		},
		children: [
			// Planned tasks
			{
				path: 'planned-tasks',
				name: 'CompanyGroupProjectTasksModulePlannedTasksPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupProjectTasksModulePlannedTasksTablePage',
					titleTranslationKey: 'menu.plannedTasks',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupProjectTasksModulePlannedTasksTablePage',
						component: () => import('@/views/company/project-tasks-group/planned-tasks-module/CompanyModulePlannedTasksTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			// Tasks and works
			{
				path: 'tasks-and-works',
				name: 'CompanyGroupProjectTasksModuleTasksAndWorksPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupProjectTasksModuleTasksAndWorksTablePage',
					titleTranslationKey: 'menu.tasksAndWorks',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupProjectTasksModuleTasksAndWorksTablePage',
						component: () => import('@/views/company/project-tasks-group/tasks-and-works-module/CompanyModuleTasksAndWorksTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		],
	},

	// Car park
	{
		path: 'gps-monitoring',
		name: COMPANY_GROUPS_NAMES.CAR_PARK__GPS_MONITORING,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.CAR_PARK,
			defaultModule: 'CompanyGroupGpsMonitoringModuleMovementsPage',
			iconKey: 'monitoring',
			titleTranslationKey: 'menu.GPS monitoring',
		},
		children: [
			{
				path: 'movements',
				name: 'CompanyGroupGpsMonitoringModuleMovementsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.MACHINES.MOVEMENTS_MAP,
					titleTranslationKey: 'menu.Movements',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.MACHINES.MOVEMENTS_TABLE,
						component: () => import('@/views/company/gps-monitoring-group/movements-module/CompanyModuleMovementsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: ROUTER_NAMES.MACHINES.MOVEMENTS_MAP,
						component: () => import('@/views/company/gps-monitoring-group/movements-module/CompanyModuleMovementsMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'sensors-readings',
				name: 'CompanyGroupGpsMonitoringModuleSensorsReadingsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupGpsMonitoringModuleSensorsReadingsTablePage',
					titleTranslationKey: 'menu.Sensors readings',
					hideInProduction: true,
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupGpsMonitoringModuleSensorsReadingsDashboardPage',
						component: () => import('@/views/company/gps-monitoring-group/sensors-readings-module/CompanyModuleSensorsReadingsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupGpsMonitoringModuleSensorsReadingsTablePage',
						component: () => import('@/views/company/gps-monitoring-group/sensors-readings-module/CompanyModuleSensorsReadingsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupGpsMonitoringModuleSensorsReadingsMapPage',
						component: () => import('@/views/company/gps-monitoring-group/sensors-readings-module/CompanyModuleSensorsReadingsMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'dispatcher',
				name: 'CompanyGroupGpsMonitoringModuleDispatcherPage',
				component: () => import('@/views/company/gps-monitoring-group/CompanyModuleDispatcherView.vue'),
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					titleTranslationKey: 'menu.Dispatcher',
					isDynamicComponent: true,
				},
			},
		]
	},

	{
		path: 'technique-and-equipment',
		name: COMPANY_GROUPS_NAMES.CAR_PARK__TECHNIQUE_AND_EQUIPMENT,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.CAR_PARK,
			defaultModule: 'CompanyGroupTechniqueAndEquipmentModuleTechniquePage',
			iconKey: 'devices',
			titleTranslationKey: 'menu.Technique and equipment',
		},
		children: [
			{
				path: 'technique',
				name: 'CompanyGroupTechniqueAndEquipmentModuleTechniquePage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.MACHINES.TABLE,
					titleTranslationKey: 'menu.Technique',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.MACHINES.TABLE,
						component: () => import('@/views/company/technique-and-equipment-group/technique-module/CompanyModuleTechniqueTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'equipment',
				name: 'CompanyGroupTechniqueAndEquipmentModuleEquipmentPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndEquipmentModuleEquipmentTablePage',
					titleTranslationKey: 'menu.Equipment',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndEquipmentModuleEquipmentTablePage',
						component: () => import('@/views/company/technique-and-equipment-group/equipment-module/CompanyModuleEquipmentTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'devices-and-sensors',
				name: 'CompanyGroupTechniqueAndEquipmentModuleDevicesAndSensorsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndEquipmentModuleDevicesAndSensorsTablePage',
					titleTranslationKey: 'menu.Devices and sensors',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndEquipmentModuleDevicesAndSensorsTablePage',
						component: () => import('@/views/company/technique-and-equipment-group/devices-and-sensors-module/CompanyModuleDevicesAndSensorsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'identifiers',
				name: 'CompanyGroupTechniqueAndEquipmentModuleIdentifiersPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndEquipmentModuleIdentifiersTablePage',
					titleTranslationKey: 'menu.Identifiers',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndEquipmentModuleIdentifiersTablePage',
						component: () => import('@/views/company/technique-and-equipment-group/identifiers-module/CompanyModuleIdentifiersTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	// Reports
	{
		path: 'all-works',
		name: COMPANY_GROUPS_NAMES.REPORTS__ALL_WORKS,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REPORTS,
			defaultModule: 'CompanyGroupAllWorksModuleDynamicsPage',
			iconKey: 'works',
			titleTranslationKey: 'menu.All works',
		},
		children: [
			{
				path: 'dynamics',
				name: 'CompanyGroupAllWorksModuleDynamicsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleDynamicsTablePage',
					titleTranslationKey: 'menu.Dynamics',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleDynamicsTablePage',
						component: () => import('@/views/company/all-works-group/dynamics-module/CompanyModuleDynamicsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'reporting',
				name: 'CompanyGroupAllWorksModuleReportingPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleReportingTablePage',
					titleTranslationKey: 'menu.Reporting',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleReportingTablePage',
						component: () => import('@/views/company/all-works-group/reporting-module/CompanyModuleReportingTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'quality',
				name: 'CompanyGroupAllWorksModuleQualityPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleQualityTablePage',
					titleTranslationKey: 'menu.Quality',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleQualityTablePage',
						component: () => import('@/views/company/all-works-group/quality-module/CompanyModuleQualityTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'plan-fact',
				name: 'CompanyGroupAllWorksModulePlanFactPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModulePlanFactTablePage',
					titleTranslationKey: 'menu.Plan/actual',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModulePlanFactTablePage',
						component: () => import('@/views/company/all-works-group/plan-fact-module/CompanyModulePlanFactTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'by-employees',
				name: 'CompanyGroupAllWorksModuleByEmployeesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleByEmployeesTablePage',
					titleTranslationKey: 'menu.By employees',

					hideInProduction: true,
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleByEmployeesTablePage',
						component: () => import('@/views/company/all-works-group/by-employees-module/CompanyModuleByEmployeesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'by-technique',
				name: 'CompanyGroupAllWorksModuleByTechniquePage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleByTechniqueTablePage',
					titleTranslationKey: 'menu.By technique',

					hideInProduction: true,
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleByTechniqueTablePage',
						component: () => import('@/views/company/all-works-group/by-technique-module/CompanyModuleByTechniqueTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'resource-consumption',
				name: 'CompanyGroupAllWorksModuleResourceConsumptionPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleResourceConsumptionTablePage',
					titleTranslationKey: 'menu.Resource consumption',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleResourceConsumptionTablePage',
						component: () => import('@/views/company/all-works-group/resource-consumption-module/CompanyModuleResourceConsumptionTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'productivity',
				name: 'CompanyGroupAllWorksModuleProductsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleProductsTablePage',
					titleTranslationKey: 'menu.Products',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleProductsTablePage',
						component: () => import('@/views/company/all-works-group/products-module/CompanyModuleProductsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'daily-summary',
				name: 'CompanyGroupAllWorksModuleDailySummaryPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupAllWorksModuleDailySummaryTablePage',
					titleTranslationKey: 'menu.Daily summary',

					hideInProduction: true,
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupAllWorksModuleDailySummaryTablePage',
						component: () => import('@/views/company/all-works-group/daily-summary-module/CompanyModuleDailySummaryTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'technique-and-devices',
		name: COMPANY_GROUPS_NAMES.REPORTS__TECHNIQUE_AND_DEVICES,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REPORTS,
			defaultModule: 'CompanyGroupTechniqueAndDevicesModuleFuelByDevicesPage',
			iconKey: 'gasStation',
			titleTranslationKey: 'menu.Technique and devices',
		},
		children: [
			{
				path: 'fuel-by-devices',
				name: 'CompanyGroupTechniqueAndDevicesModuleFuelByDevicesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndDevicesModuleFuelByDevicesTablePage',
					titleTranslationKey: 'menu.Fuel by devices',
				},
				children: [
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndDevicesModuleFuelByDevicesTablePage',
						component: () => import('@/views/company/technique-and-devices-group/fuel-by-devices-module/CompanyModuleFuelByDevicesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'refueling-technique',
				name: 'CompanyGroupTechniqueAndDevicesModuleRefuelingTechniquePage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndDevicesModuleRefuelingTechniqueTablePage',
					titleTranslationKey: 'menu.Refueling technique',
				},
				children: [
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndDevicesModuleRefuelingTechniqueTablePage',
						component: () => import('@/views/company/technique-and-devices-group/refueling-technique-module/CompanyModuleRefuelingTechniqueTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'device-mounting',
				name: 'CompanyGroupTechniqueAndDevicesModuleDeviceMountingPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndDevicesModuleDeviceMountingTablePage',
					titleTranslationKey: 'menu.Device mounting',
				},
				children: [
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndDevicesModuleDeviceMountingTablePage',
						component: () => import('@/views/company/technique-and-devices-group/device-mounting-module/CompanyModuleDeviceMountingTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'technique-load',
				name: 'CompanyGroupTechniqueAndDevicesModuleTechniqueLoadPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupTechniqueAndDevicesModuleTechniqueLoadTablePage',
					titleTranslationKey: 'menu.Technique load',

					hideInProduction: true,
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupTechniqueAndDevicesModuleTechniqueLoadTablePage',
						component: () => import('@/views/company/technique-and-devices-group/technique-load-module/CompanyModuleTechniqueLoadTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			}
		]
	},

	{
		path: 'inventory-control',
		name: COMPANY_GROUPS_NAMES.REPORTS__INVENTORY_CONTROL,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REPORTS,
			defaultModule: 'CompanyGroupInventoryControlModuleWeighInsPage',
			iconKey: 'resources',
			titleTranslationKey: 'menu.Warehouse management',
		},
		children: [
			{
				path: 'weigh-ins',
				name: 'CompanyGroupInventoryControlModuleWeighInsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleWeighInsTablePage',
					titleTranslationKey: 'menu.Weigh ins',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupInventoryControlModuleWeighInsDashboardPage',
						component: () => import('@/views/company/inventory-control-group/weigh-ins-module/CompanyModuleWeighInsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleWeighInsTablePage',
						component: () => import('@/views/company/inventory-control-group/weigh-ins-module/CompanyModuleWeighInsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'unloading-harvesters',
				name: 'CompanyGroupInventoryControlModuleUnloadingHarvestersPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleUnloadingHarvestersTablePage',
					titleTranslationKey: 'menu.unloadingHarvesters',
				},
				children: [
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleUnloadingHarvestersTablePage',
						component: () => import('@/views/company/inventory-control-group/unloading-harvesters-module/CompanyModuleUnloadingHarvestersTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'remains',
				name: 'CompanyGroupInventoryControlModuleRemainsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleRemainsTablePage',
					titleTranslationKey: 'menu.Remains',
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleRemainsTablePage',
						component: () => import('@/views/company/inventory-control-group/remains-module/CompanyModuleRemainsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'movement',
				name: 'CompanyGroupInventoryControlModuleMovementPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleMovementTablePage',
					titleTranslationKey: 'menu.Movement',
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleMovementTablePage',
						component: () => import('@/views/company/inventory-control-group/movement-module/CompanyModuleMovementTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'demand-forecast',
				name: 'CompanyGroupInventoryControlModuleDemandForecastPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleDemandForecastTablePage',
					titleTranslationKey: 'menu.Demand forecast',

					hideInProduction: true,
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleDemandForecastTablePage',
						component: () => import('@/views/company/inventory-control-group/demand-forecast-module/CompanyModuleDemandForecastTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'receipts-and-shipments',
				name: 'CompanyGroupInventoryControlModuleReceiptsAndShipmentsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleReceiptsAndShipmentsTablePage',
					titleTranslationKey: 'menu.Receipts and shipments',
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleReceiptsAndShipmentsTablePage',
						component: () => import('@/views/company/inventory-control-group/receipts-and-shipments-module/CompanyModuleReceiptsAndShipmentsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'grain-lab-samples',
				name: 'CompanyGroupInventoryControlModuleGrainLabSamplesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleGrainLabSamplesTablePage',
					titleTranslationKey: 'menu.Grain lab samples',
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleGrainLabSamplesTablePage',
						component: () => import('@/views/company/inventory-control-group/grain-lab-samples-module/CompanyModuleGrainLabSamplesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'waybills-registry',
				name: 'CompanyGroupInventoryControlModuleWaybillsRegistryPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleWaybillsRegistryTablePage',
					titleTranslationKey: 'menu.Waybills registry',
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleWaybillsRegistryTablePage',
						component: () => import('@/views/company/inventory-control-group/waybills-registry-module/CompanyModuleWaybillsRegistryTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'elevator-balances',
				name: 'CompanyGroupInventoryControlModuleElevatorBalancesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupInventoryControlModuleElevatorBalancesTablePage',
					titleTranslationKey: 'menu.Elevator balances',
				},
				children: [
					// not implemented
					{
						path: 'table',
						name: 'CompanyGroupInventoryControlModuleElevatorBalancesTablePage',
						component: () => import('@/views/company/inventory-control-group/elevator-balances-module/CompanyModuleElevatorBalancesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'economy',
		name: COMPANY_GROUPS_NAMES.REPORTS__ECONOMY,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REPORTS,
			defaultModule: 'CompanyGroupEconomyModuleEmployeeAccrualsPage',
			iconKey: 'activity',
			titleTranslationKey: 'menu.Economy',
		},
		children: [
			{
				path: 'balance',
				name: 'CompanyGroupEconomyModuleBalancePage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupEconomyModuleBalanceTablePage',
					titleTranslationKey: 'menu.Balance',

					hideInProduction: true,
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupEconomyModuleBalanceDashboardPage',
						component: () => import('@/views/company/economy-group/balance-module/CompanyModuleBalanceDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupEconomyModuleBalanceTablePage',
						component: () => import('@/views/company/economy-group/balance-module/CompanyModuleBalanceTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupEconomyModuleBalanceMapPage',
						component: () => import('@/views/company/economy-group/balance-module/CompanyModuleBalanceMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'pnl',
				name: 'CompanyGroupEconomyModulePnlPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupEconomyModulePnlTablePage',
					titleTranslationKey: 'menu.PNL',

					hideInProduction: true,
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupEconomyModulePnlDashboardPage',
						component: () => import('@/views/company/economy-group/pnl-module/CompanyModulePnlDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupEconomyModulePnlTablePage',
						component: () => import('@/views/company/economy-group/pnl-module/CompanyModulePnlTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupEconomyModulePnlMapPage',
						component: () => import('@/views/company/economy-group/pnl-module/CompanyModulePnlMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'employee-accruals',
				name: 'CompanyGroupEconomyModuleEmployeeAccrualsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupEconomyModuleEmployeeAccrualsTablePage',
					titleTranslationKey: 'menu.Employee accruals',
				},
				children: [
					// refactored table
					{
						path: 'table',
						name: 'CompanyGroupEconomyModuleEmployeeAccrualsTablePage',
						component: () => import('@/views/company/economy-group/employee-accruals-module/CompanyModuleEmployeeAccrualsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'service-charges',
				name: 'CompanyGroupEconomyModuleServiceChargesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupEconomyModuleServiceChargesTablePage',
					titleTranslationKey: 'menu.Service charges',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupEconomyModuleServiceChargesTablePage',
						component: () => import('@/views/company/economy-group/service-charges-module/CompanyModuleServiceChargesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'cost-of-work',
				name: 'CompanyGroupEconomyModuleCostOfWorkPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupEconomyModuleCostOfWorkTablePage',
					titleTranslationKey: 'menu.Cost of work',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupEconomyModuleCostOfWorkTablePage',
						component: () => import('@/views/company/economy-group/cost-of-work-module/CompanyModuleCostOfWorkTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'financial-plan-fact',
				name: 'CompanyGroupEconomyModuleFinancialPlanPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupEconomyModuleFinancialPlanTablePage',
					titleTranslationKey: 'menu.Financial plan fact',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupEconomyModuleFinancialPlanTablePage',
						component: () => import('@/views/company/economy-group/financial-plan-module/CompanyModuleFinancialPlanTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'condition-of-crops',
		name: COMPANY_GROUPS_NAMES.REPORTS__CONDITION_OF_CROPS,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REPORTS,
			defaultModule: 'CompanyGroupConditionOfCropsDynamicsVegetationPage',
			iconKey: 'heterogeneityZone',
			titleTranslationKey: 'menu.Condition of crops',
		},
		children: [
			{
				path: 'dynamics-of-vegetation',
				name: 'CompanyGroupConditionOfCropsDynamicsVegetationPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupConditionOfCropsDynamicsVegetationMapPage',
					titleTranslationKey: 'menu.Dynamics of vegetation',
				},
				children: [
					{
						path: 'map',
						name: 'CompanyGroupConditionOfCropsDynamicsVegetationMapPage',
						component: () => import('@/views/company/condition-of-crops-group/dynamics-of-vegetation-module/CompanyModuleDynamicsVegetationMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	// Real estate
	{
		path: 'real-estate',
		name: COMPANY_GROUPS_NAMES.REAL_ESTATE__INFRASTRUCTURE,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REAL_ESTATE,
			defaultModule: 'CompanyGroupRealEstateModuleBuildingsAndSitesPage',
			iconKey: 'company',
			titleTranslationKey: 'menu.Real estate',
		},
		children: [
			{
				path: 'buildings-and-sites',
				name: 'CompanyGroupRealEstateModuleBuildingsAndSitesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupRealEstateModuleBuildingsAndSitesMapPage',
					titleTranslationKey: 'menu.Buildings and sites',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupRealEstateModuleBuildingsAndSitesDashboardPage',
						component: () => import('@/views/company/real-estate-group/buildings-and-sites-module/CompanyModuleBuildingsAndSitesDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupRealEstateModuleBuildingsAndSitesTablePage',
						component: () => import('@/views/company/real-estate-group/buildings-and-sites-module/CompanyModuleBuildingsAndSitesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupRealEstateModuleBuildingsAndSitesMapPage',
						component: () => import('@/views/company/real-estate-group/buildings-and-sites-module/CompanyModuleBuildingsAndSitesMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'filling-stations',
				name: 'CompanyGroupRealEstateModuleFillingStationsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupRealEstateModuleFillingStationsTablePage',
					titleTranslationKey: 'menu.Fuel stations',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupRealEstateModuleFillingStationsDashboardPage',
						component: () => import('@/views/company/real-estate-group/filling-stations-module/CompanyModuleFillingStationsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupRealEstateModuleFillingStationsTablePage',
						component: () => import('@/views/company/real-estate-group/filling-stations-module/CompanyModuleFillingStationsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: 'CompanyGroupRealEstateModuleFillingStationsMapPage',
						component: () => import('@/views/company/real-estate-group/filling-stations-module/CompanyModuleFillingStationsMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'weight-complexes',
				name: 'CompanyGroupRealEstateModuleWeightComplexesPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupRealEstateModuleWeightComplexesTablePage',
					titleTranslationKey: 'menu.Weightbridges',
				},
				children: [
					{
						path: 'table',
						name: 'CompanyGroupRealEstateModuleWeightComplexesTablePage',
						component: () => import('@/views/company/real-estate-group/weight-complexes-module/CompanyModuleWeightComplexesTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		]
	},

	{
		path: 'land-bank',
		name: COMPANY_GROUPS_NAMES.REAL_ESTATE__LAND_BANK,
		component: CompanyGroupDefaultView,
		meta: {
			navigationRouteType: NAVIGATION_ROUTE_TYPES.group.key,
			categoryKey: CATEGORY_GROUP_KEYS.REAL_ESTATE,
			defaultModule: 'CompanyGroupLandBankModuleFieldsPage',
			iconKey: 'landBank',
			titleTranslationKey: 'menu.landBank',
		},
		children: [
			{
				path: 'fields',
				name: 'CompanyGroupLandBankModuleFieldsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView:  ROUTER_NAMES.FIELDS.MAP,
					titleTranslationKey: 'menu.Fields',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.FIELDS.TABLE,
						component: () => import('@/views/company/land-bank-group/fields-module/CompanyModuleFieldsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: ROUTER_NAMES.FIELDS.MAP,
						component: () => import('@/views/company/land-bank-group/fields-module/CompanyModuleFieldsMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'comparison',
						name: 'CompanyGroupLandBankModuleFieldsComparisonPage',
						component: () => import('@/views/company/land-bank-group/fields-module/CompanyModuleFieldsComparisonView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
							hideInProduction: true,
						},
					},
				],
			},
			{
				path: 'land',
				name: 'CompanyGroupLandBankModuleLandPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.LAND_BANK.LANDS.MAP,
					titleTranslationKey: 'menu.Land',
				},
				children: [
					{
						path: 'table',
						name: ROUTER_NAMES.LAND_BANK.LANDS.TABLE,
						component: () => import('@/views/company/land-bank-group/land-module/CompanyModuleLandTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'map',
						name: ROUTER_NAMES.LAND_BANK.LANDS.MAP,
						component: () => import('@/views/company/land-bank-group/land-module/CompanyModuleLandMapView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
			{
				path: 'cadastral-documents',
				name: 'CompanyGroupLandBankModuleCadastralDocumentsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: 'CompanyGroupLandBankModuleCadastralDocumentsTablePage',
					titleTranslationKey: 'menu.Cadastral documents',
				},
				children: [
					{
						path: 'dashboard',
						name: 'CompanyGroupLandBankModuleCadastralDocumentsDashboardPage',
						component: () => import('@/views/company/land-bank-group/cadastral-documents-module/CompanyModuleCadastralDocumentsDashboardView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
					{
						path: 'table',
						name: 'CompanyGroupLandBankModuleCadastralDocumentsTablePage',
						component: () => import('@/views/company/land-bank-group/cadastral-documents-module/CompanyModuleCadastralDocumentsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
					{
						path: 'schedule',
						name: 'CompanyGroupLandBankModuleCadastralDocumentsSchedulePage',
						component: () => import('@/views/company/land-bank-group/cadastral-documents-module/CompanyModuleCadastralDocumentsScheduleView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,

							hideInProduction: true,
						},
					},
				],
			},

			{
				path: 'documents',
				name: 'CompanyGroupLandBankModuleDocumentsPage',
				component: CompanyModuleDefaultView,
				meta: {
					navigationRouteType: NAVIGATION_ROUTE_TYPES.module.key,
					defaultTabView: ROUTER_NAMES.LAND_BANK.LAND_DOCUMENTS.TABLE,
					titleTranslationKey: 'menu.Documents',
				},
				children: [
					// refactored table
					{
						path: 'table',
						name: ROUTER_NAMES.LAND_BANK.LAND_DOCUMENTS.TABLE,
						component: () => import('@/views/company/land-bank-group/documents-module/CompanyModuleDocumentsTableView.vue'),
						meta: {
							navigationRouteType: NAVIGATION_ROUTE_TYPES.view.key,
							isDynamicComponent: true,
						},
					},
				],
			},
		],
	},
]
